<template>
  <div class="simulation__menu">
    <item-header
      v-if="!loadedModel.simulationLocked"
      type="simulation"
      :choosable="true"
      :with-dropdown="true"
      :selected-id="simulation?.id"
      @select="selectSimulation"
    />
    <menu-group v-if="!loadedModel.simulationControlsHidden">
      <player-controls v-if="simulation" />
    </menu-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import MenuGroup from "@core/ui/MenuGroup.vue";
import ItemHeader from "@editor/components/ItemHeader.vue";

import PlayerControls from "@editor/items/simulation/PlayerControls.vue";

import { showMessage } from "@core/ui/alert/alert";
import { useLoadedModel } from "@editor/store/loadedModel.store";
import { useSimulationViewStore } from "@editor/views/simulation/simulationView.store";

const { t } = useI18n();
const { loadedModel } = useLoadedModel();

const simulationView = useSimulationViewStore();

const simulation = computed(() => simulationView.simulation);
const simulating = computed(() => simulationView.simulating || simulationView.autoplayActive);

function selectSimulation(simulationId: number | null) {
  if (simulationId == null && simulating.value) {
    showMessage(t("messages.waitUntilRoundEnd"));
    return;
  }
  simulationView.loadSimulation({
    simulationId: simulationId
  });
}
</script>

<style lang="scss">
.simulation__menu {
  box-shadow: 0 0 10px var(--color-shadow-2);
  position: sticky;
  top: 0;
  background-color: var(--color-background-deep);
  z-index: 2;

  &__title {
    margin-right: auto;
  }

  &__button_grid {
    display: grid;
    grid-template-columns: minmax(min-content, 1fr) minmax(min-content, 1fr);
    gap: 0.5rem;
  }
}
</style>
